module.exports = __webpack_public_path__ + "static/img/1.7ead7c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/dice/1.png
// module id = XvqA
// module chunks = 2